import { isEqual } from "es-toolkit";

export function getDifferences<T extends Record<string, unknown>>(
  A: T | null | undefined,
  B: T | null | undefined,
): Partial<T> {
  if (!A && B) {
    return B;
  }

  if (A && !B) {
    return A;
  }

  if (!A && !B) {
    return {};
  }

  const differences: Partial<T> = {};

  const allKeys = new Set([...Object.keys(A!), ...Object.keys(B!)]);

  for (const key of allKeys) {
    if (typeof A![key] === "object" && typeof B![key] === "object") {
      if (!isEqual(A![key], B![key])) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (differences as any)[key] = B![key] !== undefined ? B![key] : A![key];
      }
    } else if (A![key] !== B![key]) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (differences as any)[key] = B![key] !== undefined ? B![key] : A![key];
    }
  }

  return differences;
}
